import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1601"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M13.745 8.027V3.749c0-1.626-1.323-2.95-2.95-2.95s-2.95 1.324-2.95 2.95v4.278a4.178 4.178 0 0 0-1.25 2.968c0 2.316 1.885 4.2 4.2 4.2s4.2-1.884 4.2-4.2a4.176 4.176 0 0 0-1.25-2.968zm-2.95 5.768a2.803 2.803 0 0 1-2.8-2.8 2.79 2.79 0 0 1 1.002-2.126.701.701 0 0 0 .248-.534V3.749c0-.854.695-1.55 1.55-1.55s1.55.695 1.55 1.55v4.586a.7.7 0 0 0 .248.534 2.788 2.788 0 0 1 1.002 2.126c0 1.544-1.256 2.8-2.8 2.8z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M11.245 9.403V5.275a.5.5 0 0 0-1 0v4.141a1.754 1.754 0 0 0 .522 3.431 1.76 1.76 0 0 0 1.759-1.759c0-.805-.543-1.476-1.281-1.685zM6.399 3.147c-.925.272-1.185 1.055-1.126 1.545-.66-.801-.707-1.725-.633-3.051-2.116.824-1.624 3.201-1.687 3.923-.533-.45-.633-1.525-.633-1.525-.562.298-.844 1.096-.844 1.743 0 1.565 1.26 2.705 2.775 2.705s2.711-1.141 2.711-2.705c-.001-.93-.641-1.237-.563-2.635z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }